// extracted by mini-css-extract-plugin
export default {"container":"LegalPage_container__Ev6OG","item":"LegalPage_item__UQ-az"};